import { DataItemType, FormControlType } from "@cloudpivot/form/schema";
import schema from "./schema";
import conduct from "./conduct";
import design from "./components/design.vue";
import pc from "./components/pc-input-logic.vue";
import mobile from "./components/mobile-input-logic.vue";
const info = {
    title: "逻辑",
    type: "logic",
    icon: "h-icon-all-logic-switch-o",
    dataItemType: DataItemType.Logic,
    formControllerType: FormControlType.Logic,
    group: "基础控件",
};
export default {
    info,
    schema,
    conduct,
    components: {
        design,
        pc,
        mobile
    },
};
